<template lang="pug">
    v-container(fill-height fluid pa-0 ma-0 class="full-page-height")
        v-row(no-gutters v-if="loading" align="center" justify="center" fill-height)
            v-col(cols="12" class="text-center")
                v-progress-circular(indeterminate color="primary" size="64")
        v-row(no-gutters v-else align="start")
            v-col()
                v-card(elevation="0" pa-0 ma-0)
                    v-card-text(class="pa-1")
                        div(v-if="summary" v-html="summary" class="summary-text")
                        p(v-else) No summary available.
</template>

<style scoped>
.full-page-height {
    min-height: 100vh;
}
.summary-text {
    white-space: pre-wrap;
    line-height: 1.6;
    font-size: .9rem;
    color: #333;
    padding: 16px;
    background-color: #f9f9f9;
    border-radius: 8px;
    border: 1px solid #eee;
}
</style>

<script>
export default {
    name: 'aiSummary',
    data() {
        return {
            summary: null,
            loading: false
        }
    },
    mounted() {
        const accountId = this.$route.query.id
        if (accountId) {
            this.fetchSummary(accountId)
        }
    },
    methods: {
        async fetchSummary(accountId) {
            this.loading = true
            try {
                const response = await this.$http.get(`https://flux.local.xprt.com/webhook/account-summary/`, {
                    params: {
                        accountid: accountId
                    }
                })
                this.summary = response.data.message
            } catch (error) {
                console.error('Error fetching AI summary:', error)
                this.summary = 'Error loading summary. Please try again later.'
            } finally {
                this.loading = false
            }
        }
    }
}
</script>